<template>
    <div class="realGift-layer"></div>
</template>

<script>
    //script
    import Tools from '../../scripts/tools';
    //Global
    import Global from '../../scripts/Global';

    export default {
        data() {
            return {
                data: {},
            };
        },
        created() {
            this.fetchData()
        },
        watch: {
            '$route': 'fetchData'
        },
        computed: {
            giftType() {
                return this.$route.query.giftType
            }
        },
        methods: {
            fetchData() {
                this.giftType == this.$route.query.giftType;
                if (!this.$route.query.giftType) {
                    this.$router.replace({name: 'Home', query: {gameType: 'guide'}});
                }
            },
            jump(event) {
                if (event) {
                    Global.curr = {
                        ...data,
                    };
                    Global.ssq.b1 = true;
                    this.$router.replace('/yu');
                } else {
                    this.$router.replace('/rodemap/ssq/03');
                }
                console.log(event, 'event');
            },
        },
    };
</script>

<style rel="stylesheet/scss" lang="scss">
    .realGift-layer {@include fullLayer}
</style>
